import { ResultType } from 'Types/common';
import QuestionList from '../QuestionsList';

const InformationContainer = ({ data }: { data: ResultType }): JSX.Element => {
  return <QuestionList data={data} />;
};

export default InformationContainer;
